import styled from 'styled-components';

export const SettingsLabel = styled.label`
  color: #b9bad6; // TODO: Use CSS variable
  font-size: 0.9rem;

  white-space: nowrap;
  padding: 0 4px;
`;
